<template>
  <div
    v-if="user.permission !== 2"
    :style="{ height: height + 'px !important' }"
    class="parent-form"
  >
    <div v-if="isClickRecommend" class="recommend">
      <div style="display: flex; justify-content: space-between; width: 100%">
        <a class="card-button-ok" @click="textareaApplyCalendar()">
          <span class="mdi mdi-clipboard-check-outline"></span>候補日時を反映
        </a>
        <a class="card-button-close is-primary" @click="closeRecommendCard()">
          <span class="mdi mdi-close"></span>閉じる
        </a>
      </div>
      <!-- 日程候補カード -->
      <div
        v-if="isClickRecommend && isCalculatedRecommend"
        style="display: flex; justify-content: space-evenly; align-items: center; width: 100%"
      >
        <div class="card recommend-date-left" style="margin: 10px; border-radius: 10px">
          <p v-if="recommendDateBfr[0].start !== 0" class="beforeEvent">
            前：{{ recommendDateBfr[0].start }} - {{ recommendDateBfr[0].end }}
          </p>
          <p v-else class="beforeEvent">前：イベントなし</p>
          <p class="mainEvent">{{ recommendDate[0].start }} - {{ recommendDate[0].end }}</p>
          <p v-if="recommendDateAft[0].start !== 0" class="afterEvent">
            後：{{ recommendDateAft[0].start }} - {{ recommendDateAft[0].end }}
          </p>
          <p v-else class="afterEvent">後：イベントなし</p>
        </div>
        <div class="card recommend-date-left" style="margin: 10px; border-radius: 10px">
          <p v-if="recommendDateBfr[1].start !== 0" class="beforeEvent">
            前：{{ recommendDateBfr[1].start }} - {{ recommendDateBfr[1].end }}
          </p>
          <p v-else class="beforeEvent">前：イベントなし</p>
          <p class="mainEvent">{{ recommendDate[1].start }} - {{ recommendDate[1].end }}</p>
          <p v-if="recommendDateAft[1].start !== 0" class="afterEvent">
            {{ recommendDateAft[1].start }} - {{ recommendDateAft[1].end }}
          </p>
          <p v-else class="afterEvent">後：イベントなし</p>
        </div>
        <div class="card recommend-date-left" style="margin: 10px; border-radius: 10px">
          <p v-if="recommendDateBfr[2].start !== 0" class="beforeEvent">
            前：{{ recommendDateBfr[2].start }} - {{ recommendDateBfr[2].end }}
          </p>
          <p v-else class="beforeEvent">前：イベントなし</p>
          <p class="mainEvent">{{ recommendDate[2].start }} - {{ recommendDate[2].end }}</p>
          <p v-if="recommendDateAft[2].start !== 0" class="afterEvent">
            後：{{ recommendDateAft[2].start }} - {{ recommendDateAft[2].end }}
          </p>
          <p v-else class="afterEvent">後：イベントなし</p>
        </div>
        <div class="card recommend-date-left" style="margin: 10px; border-radius: 10px">
          <p v-if="recommendDateBfr[3].start !== 0" class="beforeEvent">
            前：{{ recommendDateBfr[3].start }} - {{ recommendDateBfr[3].end }}
          </p>
          <p v-else class="beforeEvent">前：イベントなし</p>
          <p class="mainEvent">{{ recommendDate[3].start }} - {{ recommendDate[3].end }}</p>
          <p v-if="recommendDateAft[3].start !== 0" class="afterEvent">
            後：{{ recommendDateAft[3].start }} - {{ recommendDateAft[3].end }}
          </p>
          <p v-else class="afterEvent">後：イベントなし</p>
        </div>
        <div class="card recommend-date-left" style="margin: 10px; border-radius: 10px">
          <p v-if="recommendDateBfr[4].start !== 0" class="beforeEvent">
            前：{{ recommendDateBfr[4].start }} - {{ recommendDateBfr[4].end }}
          </p>
          <p v-else class="beforeEvent">前：イベントなし</p>
          <p class="mainEvent">{{ recommendDate[4].start }} - {{ recommendDate[4].end }}</p>
          <p v-if="recommendDateAft[4].start !== 0" class="afterEvent">
            後：{{ recommendDateAft[4].start }} - {{ recommendDateAft[4].end }}
          </p>
          <p v-else class="afterEvent">後：イベントなし</p>
        </div>
      </div>
    </div>
    <div :style="{ height: height + 'px !important' }" class="child-form">
      <textarea
        :style="{ height: height + 'px !important' }"
        v-model="chatData.message"
        icon="message"
        size="is-large"
        style="background: rgba(255, 255, 255, 0.1) !important"
        placeholder="Ctrl+Enter 送信"
        type="textarea"
        expanded
        @keydown.ctrl.enter="submit()"
        @keydown.meta.enter="submit()"
      >
      </textarea>
      <div :style="{ height: height + 'px !important' }" class="btn-menu">
        <Picker
          v-show="isOpenEmoji"
          title="Pick your emoji…"
          style="position: fixed; bottom: 60px; left: 250px"
          @select="selectEmoji"
        />
        <p>
          <button
            class="button is-large"
            style="background-color: #fefefe; border: none"
            @click="isOpenEmoji = !isOpenEmoji"
          >
            <span class="mdi mdi-emoticon" style="color: #313e4d"></span>
          </button>
        </p>
        <!-- <p>
            <button class="button is-large"
                    style="background-color: #FEFEFE; border: none; margin-top: 5px;"
                    @click="openRecommendCard()">
            <span class="mdi mdi-calendar-text" style="color: #313E4D;"></span>
            </button>
        </p> -->
        <p>
          <button
            class="button is-large"
            style="background-color: #fefefe; border: none"
            @click="submit()"
          >
            <span class="mdi mdi-send" style="color: #313e4d"></span>
          </button>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Emoji, Picker } from 'emoji-mart-vue'
import alterReplace from '@/functions/alterStrReplace'
export default {
  name: 'InputForm',
  components: {
    Emoji,
    Picker,
    alterReplace,
  },
  data() {
    return {
      uri: location.href,
      height: 60,
      emojiSize: 24,
      perLine: 9,
      skin: 1,
      native: true,
      set: 'apple',
      hidden: false,
      currentEmoji: { id: '+1' },
      autoFocus: false,
      isOpenEmoji: false,
      include: [],
      exclude: [],
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('directtalk', ['chatData']),
    ...mapState('calendar', [
      'isClickRecommend',
      'isCalculatedRecommend',
      'recommendDate',
      'recommendDateBfr',
      'recommendDateAft',
      'isGoogleAuth',
    ]),
  },
  watch: {
    'chatData.message': function () {
      var num
      if (this.chatData.message !== '') {
        this.$store.dispatch('directtalk/isTyping', 'start_typing:' + this.user.username)
        num = this.chatData.message.match(/\r\n|\n/g)
        if (num != null) {
          if (num < 4) this.height = (num.length + 1) * 60
        } else {
          this.height = 60
        }
      } else {
        this.$store.dispatch('directtalk/isTyping', 'end_typing:' + this.user.username)
        num = this.chatData.message.match(/\r\n|\n/g)
        if (num != null) {
          if (num < 4) this.height = (num.length + 1) * 60
        } else {
          this.height = 60
        }
        // num != null ? this.height = (num.length + 1) * 60 : this.height = 60
      }
    },
  },
  methods: {
    selectEmoji(emoji) {
      console.debug('*** Start *** selectEmoji')
      console.debug('emoji: ' + JSON.stringify(emoji))
      this.chatData.message += emoji.native
      this.isOpenEmoji = false
      console.debug('*** End *** selectEmoji')
    },
    submit() {
      console.debug('*** Start *** submit')
      console.log('Tool_Email: ' + this.user.email)
      // set User Info
      this.chatData.email = this.user.email
      this.chatData.url = this.uri
      this.chatData.icon = this.user.profileIcon
      this.chatData.name = this.user.username
      this.chatData.isManager = '1'
      // set Time
      console.log('Tool: ' + this.chatData.name)
      var today = new Date()
      console.log('now: ' + today.toISOString())
      this.chatData.createdAt = today.toISOString()
      var all = {
        get_type: 'all',
      }
      this.$store.dispatch('directtalk/getRoomList', all)
      if (this.chatData.message !== '') {
        this.chatData.message = alterReplace(this.chatData.message, false)
        console.info('chatData.message is not blank')
        this.$store.dispatch('directtalk/pushChat', this.chatData)
        this.chatData.message = ''
      }
      console.debug('*** End *** submit')
    },
    textareaApplyCalendar() {
      console.debug('*** Start *** textareaApplyCalendar')
      // set Calendar
      console.log('Set Calendar: ' + this.recommendDate)
      this.$store
        .dispatch('directtalk/setCalendar', this.recommendDate)
        .then(() => this.$store.dispatch('calendar/endRecommendDate'))
      console.debug('*** End *** textareaApplyCalendar')
    },
    openRecommendCard() {
      console.debug('*** Start *** openRecommendCard')
      this.$store.dispatch('calendar/startRecommendDate')
      console.debug('*** End *** openRecommendCard')
    },
    closeRecommendCard() {
      console.debug('*** Start *** closeRecommendCard')
      this.$store.dispatch('calendar/endRecommendDate')
      console.debug('*** End *** closeRecommendCard')
    },
    insertSymbol(emoji) {
      console.debug('*** Start *** insertSymbol')
      console.debug('emoji: ' + emoji)
      console.debug('*** End *** insertSymbol')
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.parent-form {
  height: 60px;
  width: 100%;
  position: relative;
}
.child-form {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  width: 100%;
  text-align: center;
  border-top: solid thin #ccc;
  background: #fefefe;
}
.recommend {
  transition: 0.7s;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 145px;
  width: 100%;
  background: rgba(0, 0, 0, 0.2);
  bottom: 60px;
}
.card-button-ok {
  border: none;
  border-radius: 15px;
  background-color: #3498db;
  width: 40%;
  height: 40px;
  font-size: 18px;
  font-weight: 600;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}
.card-button-close {
  border: none;
  border-radius: 15px;
  width: 40%;
  height: 40px;
  background-color: #95a5a6;
  font-size: 18px;
  font-weight: 600;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}
.beforeEvent {
  /* transform: rotateX(45deg); */
  border-bottom: solid thin #ccc;
}
.mainEvent {
  background-color: #ffffcc;
}
.afterEvent {
  /* transform: rotateX(-45deg); */
  border-top: solid thin #ccc;
}
textarea {
  width: 100%;
  font-size: 18px;
  padding-top: 18px;
  padding-left: 10px;
  line-height: 25px;
  /* z-index: 9; */
  border: none;
  resize: none;
  outline: none;
  background: #fefefe;
}
button {
  width: 5vw;
  outline: none;
}
.btn-menu {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  height: 100%;
  background: #fefefe;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/DirectTalk/InputForm.vue